import { factory, FactoryService } from '@/decorators/factory';
import { User, UserLike } from '@/entities/User';
import { Logger } from '@/services/Logger';

@factory(UserController)
export class UserController implements FactoryService<User> {
  protected $activeUser: User = User.create();

  // Inject the Logger service
  private logger: Logger;

  // Inject the logger via constructor
  constructor(logger: Logger) {
    this.logger = logger;
  }

  factoryCreate(user?: User | UserLike) {
    return User.create(user);
  }

  get activeUser(): User {
    return this.$activeUser;
  }

  set activeUser(user: User | UserLike | undefined) {
    this.$activeUser = User.create(user);

    // Log user information using LogRocket's identify method
    this.logger.identify(this.$activeUser.userKey, {
      name: this.$activeUser.fullName,
      email: this.$activeUser.userName,
      company: this.$activeUser.tenantName,
      companyId: this.$activeUser.companyId,
      tenantKey: this.$activeUser.tenantKey,
      roles: this.$activeUser.roles.join(', '),
    });
  }
}
